import { render, staticRenderFns } from "./discount-item-block.vue?vue&type=template&id=09eb2472"
import script from "./discount-item-block.vue?vue&type=script&lang=js"
export * from "./discount-item-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports